import { useTranslations } from '@fshr/context/i18n-context';
import Button from '../button';

const RecentSearch = ({
	searchTerms,
	onSearch,
}: {
	searchTerms?: string[];
	onSearch: (searchTerm: string) => void;
}) => {
	const t = useTranslations();
	if (!searchTerms || searchTerms.length <= 0) {
		return null;
	}
	return (
		<div className="flex flex-col spacing-stack-xs">
			<h2 className="text-label text-text-secondary">{t('Recent Search')}</h2>
			<div className="flex flex-row flex-wrap justify-start items-center spacing-inline-s spacing-stack-s">
				{searchTerms.map(term => {
					return (
						<Button
							onClick={event => {
								event.preventDefault();
								onSearch(term);
							}}
							intent="outline"
							className="w-auto h-[50px] px-150! border-border-subtle!"
							key={`recent-search-${term}`}
						>
							<span className="text-caption text-[12px]!">{term}</span>
						</Button>
					);
				})}
			</div>
		</div>
	);
};

export default RecentSearch;
